import { SharingData } from '../../schema/SharingData';
import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';

export function isCSLWithExternalRecipients(
    sharingData: SharingData,
    recipientInfo: SharingTipRecipientInfo[]
): boolean {
    const hasExternalRecipients =
        recipientInfo.filter(recipient => {
            return recipient.ExternalMemberCount > 0;
        }).length > 0;
    return (
        hasExternalRecipients &&
        (sharingData.currentPermissionLevel === AttachmentPermissionLevel.OrganizationEdit ||
            sharingData.currentPermissionLevel === AttachmentPermissionLevel.OrganizationView)
    );
}
